$(document).ready(() => {
    $('.list-page input').change((e) => filter(e));
    $('.list-page button').click((e) => loadMore(e));
});

function loadMore(e) {
    var form = $(e.target).closest('form');
    var input = form.find('.take-input').first();
    $(input).val(parseInt(input.val()) + 6);

    submitForm(e);
}

function filter(e) {
    var id = e.target.id;
    var type = id.substr(0, id.indexOf('_'));
    var all = document.getElementById(type + '_0__Selected');

    if (type == "FirstSubTypes") {
        var elems = $('input:checkbox[id^=' + type + "]");
        elems.each((i, e) => {
            if (id != e.id) {
                e.value = false
                e.checked = null
            }
        });
    }
    else {
        if (!id.includes('0__Selected') && e.target.checked) {
            all.checked = false;
        }
        else if (id.includes('0__Selected')) {
            var elems = $('input:checkbox[id^=' + type + "]");
            elems.each((i, e) => {
                e.value = false
                e.checked = null
            });
        }
    }

    submitForm(e);
}

function submitForm(e) {
    var form = $(e.target).closest('form')[0];
    var html = $(e.target).closest('.list-page')[0];

    var valdata = $(form).serialize();
    $.ajax({
        url: $(form).attr('action'),
        type: 'Get',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: valdata,
        success: function (data) {
            $(html).html(data);
            $('.list-page input').change((e) => filter(e));
            $('.list-page button').click((e) => loadMore(e));
        },
    });
}